import { apolloProvider } from '@/apollo-provider.js'
import {
  MUTATION_UPSERT_AHUB_REPORT_ANALYTICS,
  MUTATION_ACTIVE_DELETE_AHUB_REPORT_ANALYTICS,
  QUERY_AHUB_ANALYTICS_CONFIGURATIONS,
  QUERY_AHUB_ANALYTICS_LIMITS,
  QUERY_ENTITIES_LINKED_BY_AHUB_CONFIGURATION,
} from '@/modules/gerenciador-analises/graphql'

export default {
  async generateHubAnalysis({ commit }, variables) {
    try {
      const {
        data: {
          upsertAHubReportAnalytics: { status },
        },
      } = await apolloProvider.defaultClient.mutate({
        mutation: MUTATION_UPSERT_AHUB_REPORT_ANALYTICS,
        fetchPolicy: 'no-cache',
        variables,
      })

      return status
    } catch (error) {
      console.error(error)
      return new Error()
    }
  },
  async deleteHubReportAnalytics({ commit }, variables) {
    try {
      await apolloProvider.defaultClient.mutate({
        mutation: MUTATION_ACTIVE_DELETE_AHUB_REPORT_ANALYTICS,
        fetchPolicy: 'no-cache',
        variables,
      })
    } catch (error) {
      console.error(error)
    }
  },
  async getHubAnalyticsConfigurations({ commit }, variables) {
    try {
      const { aHubAnalyticsConfigurations } = await apolloProvider.defaultClient
        .query({
          query: QUERY_AHUB_ANALYTICS_CONFIGURATIONS,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { aHubAnalyticsConfigurations } }) => {
          return aHubAnalyticsConfigurations
        })
      commit('SET_HUB_ANALYTICS_CONFIGURATIONS', { payload: aHubAnalyticsConfigurations, type: variables.type })
    } catch (error) {
      console.error(error)
      commit('SET_HUB_ANALYTICS_CONFIGURATIONS', { payload: [], type: variables.type })
    } finally {
      commit('SET_LOADING_REPORTS_LIST', false)
    }
  },
  async getHubAnalyticsLimits({ commit, dispatch }) {
    try {
      commit('SET_LOADING_REPORTS_LIST', true)
      dispatch('clearHubData')
      const { aHubAnalyticsLimits } = await apolloProvider.defaultClient
        .query({
          query: QUERY_AHUB_ANALYTICS_LIMITS,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: aHubAnalyticsLimits }) => {
          return aHubAnalyticsLimits
        })
      commit('SET_HUB_ANALYTICS_LIMITS', aHubAnalyticsLimits)
    } catch (error) {
      console.error(error)
      commit('SET_HUB_ANALYTICS_LIMITS', [])
    }
  },
  async getEntitiesLinkedByHubConfiguration({ commit }, variables) {
    try {
      const { entitiesLinkedByAhubConfiguration } = await apolloProvider.defaultClient
        .query({
          query: QUERY_ENTITIES_LINKED_BY_AHUB_CONFIGURATION,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: entitiesLinkedByAhubConfiguration }) => {
          return entitiesLinkedByAhubConfiguration
        })
      commit('SET_ENTITIES_LINKED_BY_HUB_CONFIGURATION', entitiesLinkedByAhubConfiguration)
    } catch (error) {
      console.error(error)
      commit('SET_ENTITIES_LINKED_BY_HUB_CONFIGURATION', [])
    }
  },
  clearHubData({ commit }) {
    commit('SET_HUB_ANALYTICS_LIMITS', [])
    commit('SET_HUB_ANALYTICS_CONFIGURATIONS', { payload: [], type: 'RFV' })
    commit('SET_HUB_ANALYTICS_CONFIGURATIONS', { payload: [], type: 'DRE' })
  },
}
